export const updateGTMDatalayer = dataObject => {
  window['dataLayer']?.push(dataObject);
};
